/**
 * Created by User on 19/9/2559.
 */
import {Component, HostBinding, NgZone, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { ResendVerifyEmailComponent } from '../resend-verify-email/resend-verify-email.component';
import { LoadingButtonComponent } from 'app/shared/loading-button/button';
import { Toast } from 'app/shared/toast/toast';
import { FileSizePipe } from 'app/shared/file-size.pipe';
import { TranslateService } from '@ngx-translate/core';
import { PasswordStrengthComponent } from 'app/shared/password-strength/password-strength';
import {PdpaAgreementComponent} from '../../shared/pdpa-agreement/pdpa-agreement.component';

declare let grecaptcha: any;
declare const recaptcha: string;

@Component({
   selector: 'app-sign-up',
   templateUrl: './sign-up.component.html',
   styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   @HostBinding('class') fx = 'fx-for-login flex-center';
   @ViewChild('button') signup: LoadingButtonComponent;
   errorMessage = '&nbsp;';
   registerCompany = false;
   attachments: File[] = [];
   tin: any;
   server: any;
   port: any;
   fname: string;
   lname: string;
   username: string;
   password: string;
   etaxName: string;
   etaxEmail: string;
   etaxPassword: string;
   showMailServer: boolean;
   maxFileSize = 5242880;
   busy = false;
   minLength: number;
   maxLength: number;
   newError: string;
   loading: boolean;
   visible = false;
   tel: string;
   private pdpaAgreement: MatDialogRef<PdpaAgreementComponent>;


   constructor(private service: IdexService, public dialog: MatDialog, private zone: NgZone,
               private toast: Toast, private fileSize: FileSizePipe, private router: Router,
               private translate: TranslateService) {
   }

   ngOnInit(): void {
      this.pdpaAgreement = this.dialog.open(PdpaAgreementComponent, {
         disableClose: true,
         data: { isRegister: true }
      });
      this.service.get('api/password-policy')
         .subscribe(data => {
            this.minLength = data.minLength;
            this.maxLength = data.maxLength;
         });

      this.loadCAPTCHA();
   }

   eval(): void {
      this.pwdStrength.eval(this.password, this.username, this.fname + ' ' + this.lname);
   }

   private loadCAPTCHA(): void {
      window['recaptchaCallback'] = this.recaptchaCallback.bind(this);
      if (document.getElementById('recaptcha-js')) {
         this.initRecaptcha();
         return;
      }
      window['initRecaptcha'] = this.initRecaptcha.bind(this);
      const script = document.createElement('script');
      script.id = 'recaptcha-js';
      const lang = localStorage.getItem('lang') || 'en';
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=initRecaptcha&hl=' + lang;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
   }

   initRecaptcha(): void {
      grecaptcha.render('recaptcha', {
         'sitekey': recaptcha,
         'callback': 'recaptchaCallback',
         'size': 'invisible'
      });
   }

   submitted(): void {
      this.errorMessage = '&nbsp;';
      this.busy = true;
      const token = grecaptcha.getResponse();
      if (token) {
         this.register(token);
      } else {
         grecaptcha.execute();
      }
   }

   onCancel() {
      this.router.navigate(['/login/']);
   }

   recaptchaCallback(token: string): void {
      this.zone.run((data) => {
         this.register(token);
      });
   }

   private register(token: string): void {
      if (!this.registerCompany) {
         this.service.register(this.username.toLowerCase(), this.password, this.fname, this.lname, token)
            .subscribe(
               () => {
                  this.registerSuccess(this.username);
               },
               error => {
                  let e = error;
                  try {
                     e = JSON.parse(error);
                  } catch {}
                  if (e.status === 401) {
                     this.translate.get('timeout').subscribe(s => {
                        this.toast.error(s);
                     });
                  } else if (e.status === 403) {
                     this.toast.error(e.message);
                     this.newError = e.message;
                     this.loading = false;
                  } else {
                     this.toast.error(e.message);
                     this.newError = e.message;
                     this.loading = false;
                  }
                  this.busy = false;
                  this.signup.reset();
               });
      } else {
         const data = {};
         data['email'] = this.username.toLowerCase();
         data['password'] = this.password;
         data['firstname'] = this.fname;
         data['lastname'] = this.lname;
         data['tin'] = this.tin;
         data['token'] = token;
         data['name'] = this.etaxName;
         data['cellphone'] = this.tel;
         this.service.registerwithcompany(data)
            .subscribe(
               () => {
                  this.registerSuccess(this.username);
               },
               error => {

                  let e = error;
                  try {
                     e = JSON.parse(error);
                  } catch {}
                  if (e.status === 401) {
                     this.translate.get('timeout').subscribe(s => {
                        this.toast.error(s);
                     });
                  } else if (e.status === 403) {
                     this.toast.error(e.message);
                     this.newError = e.message;
                     this.loading = false;
                  } else {
                     this.toast.error(e.message);
                     this.newError = e.message;
                     this.loading = false;
                  }
                  this.busy = false;
                  this.signup.reset();
               });
      }
   }

   registerSuccess(email: any): void {
      const register = this.dialog.open(ResendVerifyEmailComponent, {
         disableClose: true,
         data: this
      });
      register.componentInstance.email = email;
      register.afterClosed().subscribe(() => {
         this.router.navigate(['/login']);
      });
   }

   openResend() {
      this.dialog.open(ResendVerifyEmailComponent, {
         disableClose: true,
         data: this
      });
   }

   // onkeyup(item) {
   //     const reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
   //     if (item.value.length === 0) {
   //         this.error_email = false;
   //         return;
   //     } else if (!reg.test(item.value)) {
   //         this.error_email = true;
   //         return;
   //     } else {
   //         this.error_email = false;
   //     }
   // }

   detectMailServer(email: any) {
      const i = email.indexOf('@');
      const domain = i === -1 ? '' : email.substr(i + 1);
      this.showMailServer = domain.length > 0 && domain !== 'gmail.com' && domain !== 'outlook.com'
         && domain !== 'hotmail.com' && domain !== 'icloud.com' && domain !== 'yahoo.com';

   }

   onChange(input: any) {
      let error = '';
      for (let i = 0; i < input.files.length; i++) {
         const file = input.files[i];
         if (file.size > this.maxFileSize) {
            if (error) {
               error += '<br/>';
            }
            this.translate.get('alert.cert_upload_exceed', {name: file.name, size: this.fileSize.transform(file.size)})
               .subscribe(s => this.toast.error(s.toString()));
            continue;
         }
         switch (file.type) {
            case 'image/jpeg':
            case 'image/jpg':
            case 'image/png':
            case 'application/pdf':
               break;
            default:
               if (error) {
                  error += '<br/>';
               }
               this.translate.get('alert.cert_upload_error', {name: file.name}).subscribe(s => this.toast.error(s.toString()));
               continue;
         }
         this.attachments.push(file);
      }
      input.value = '';
      if (error) {
         this.toast.error(error);
      }
   }

   removeFile(file: File): void {
      const i = this.attachments.indexOf(file);
      if (i !== -1) {
         this.attachments.splice(i, 1);
      }
   }

   keyPress($event: any) {
      const pattern = /[0-9\ ]/;
      const inputChar = String.fromCharCode($event.charCode);
      if ($event.keyCode !== 8 && !pattern.test(inputChar)) {
         $event.preventDefault();
      }
   }

   checkValidateName(){
      const regex: RegExp = new RegExp(/[0-9]/g);
      if(this.fname.match(regex) || this.lname.match(regex)){
         return false;
      }
      return true;
   }
}
